import React, { useState, useEffect } from "react";
import { Box, TextField, Button, Grid2 } from "@mui/material";
import { useSnackbar } from "../../ui-components/snackbarProvider";

import AdminDBServices from "../../services/v1/adminDBServices";

const UpdatePackage = ({ packageData, fetchPackages, handleCloseDialog }) => {
  const { showSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");

  useEffect(() => {
    if (packageData) {
      setTitle(packageData.title || "");
      setDescription(packageData.description || "");
      setPrice(packageData.price || "");
    }
  }, [packageData]);

  const handleUpdate = async () => {
    try {
      const updatedData = { title, description, price };
      const res = await AdminDBServices.updatePackage(
        packageData.packageID,
        updatedData
      );
      showSnackbar(res.message, {
        severity: "success",
      });
      fetchPackages();
      handleCloseDialog();
    } catch (err) {
      console.error("Error updating package:", err);
      const errorMessage =
        err.response?.data?.message || "Failed to update package details.";
      showSnackbar(errorMessage, {
        severity: "error",
      });
    }
  };

  return (
    <Box p={2}>
      <Grid2 container spacing={2}>
        <Grid2 item size={{ xs: 12 }}>
          <TextField
            label="Package Title"
            variant="outlined"
            fullWidth
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Grid2>

        <Grid2 item size={{ xs: 12 }}>
          <TextField
            label="Description"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Grid2>

        <Grid2 item size={{ xs: 12 }}>
          <TextField
            label="Price"
            variant="outlined"
            fullWidth
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </Grid2>

        <Grid2
          item
          size={{ xs: 12 }}
          container
          justifyContent="flex-end"
          spacing={1}
        >
          <Grid2 item>
            <Button
              variant="outlined"
              color="error"
              onClick={handleCloseDialog}
            >
              Cancel
            </Button>
          </Grid2>
          <Grid2 item>
            <Button
              variant="contained"
              color="secondary"
              type="submit"
              onClick={handleUpdate}
            >
              {loading ? "Update" : "Updating..."}
            </Button>
          </Grid2>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default UpdatePackage;
